import CloudCounterIcon from "assets/Icons/icons/CloudCounterIcon";
import HomeIcon from "assets/Icons/icons/HomeIcon";
import { useIsDarkTheme } from "helpers/darktheme";
import React from "react";
import { NavLink } from "react-router-dom";

const NavTab = ({ setActiveTab }) => {
    const isDarkTheme = useIsDarkTheme();
    const [hoveredTab, setHoveredTab] = React.useState(null);

    return (
        <div className="bg-[#F7F7F7] dark:bg-[#0D1822] border-r border-[#E9E9E9] text-[15px] font-medium dark:border-[#424E59] export-cloudcounter pt-2 px-[18px] mt-[-4px] w-20">
            {[
                {
                    key: "counts",
                    to: "/cloud-counter",
                    label: "Counts",
                    Icon: CloudCounterIcon,
                },
                { key: "projects", to: "/", label: "Project", Icon: HomeIcon },
            ].map(({ key, to, label, Icon }) => (
                <NavLink
                    key={key}
                    onClick={() => setActiveTab(key)}
                    to={to}
                    onMouseEnter={() => setHoveredTab(key)}
                    onMouseLeave={() => setHoveredTab(null)}
                    className={({ isActive }) =>
                        isActive || hoveredTab === key
                            ? "text-[#E37915] border-b-2 border-[#E37915] py-2"
                            : "text-[#595959] dark:text-white hover:text-[#E37915] py-2"
                    }
                >
                    {({ isActive }) => (
                        <div className="flex flex-col items-center gap-2 pb-2">
                            <div
                                className={`py-2 px-[10px] rounded-md ${
                                    isActive || hoveredTab === key
                                        ? "bg-[#F6D5B6E5]"
                                        : ""
                                }`}
                            >
                                <Icon
                                    isActive={isActive || hoveredTab === key}
                                    isDarkTheme={isDarkTheme}
                                />
                            </div>
                            <span className="leading-6">{label}</span>
                        </div>
                    )}
                </NavLink>
            ))}
        </div>
    );
};

export default NavTab;
